<template>
  <div class="post-block" v-html="data"></div>
</template>

<script>
export default {
  name: 'Postblock',
  props: {
    html: { type: String }
  },
  computed: {
    data() {
      let strHtml = this.html
      if (strHtml) {
        strHtml = strHtml
          .replaceAll('<h5>', '<div class="faktaruta">')
          .replaceAll('</h5>', '</div>')
          .replaceAll('<h4>', '<div class="image-caption caption">')
          .replaceAll('</h4>', '</div>')
          .replaceAll(
            'https://www.havet.nu/images',
            'https://havetstore.blob.core.windows.net/bilder'
          )
      }

      return strHtml
    }
  },
  methods: {
    parseVideo() {
      if(!this.isOnline) return
      var videoElements = document.querySelectorAll('video')
      videoElements.forEach(videoElement => {
        const div = document.createElement('div')
        div.className = 'video-iframe-container'
        const iframe = document.createElement('iframe')
        iframe.className = 'video-iframe'
        iframe.allowfullscreen = ''
        iframe.allow =
          'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
        iframe.src = videoElement.src
        div.appendChild(iframe)
        videoElement.replaceWith(div)
      })
    }
  },
  mounted() {
    this.parseVideo()
  }
}
</script>
<style lang="css">
.video-iframe-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
  margin-bottom: 10px;
}

.video-iframe-container .video-iframe {
  border: 0;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
<style lang="css" scoped>
.faktaruta {
  background: url(https://www.havet.nu/livet/images/faktarutabg.png) top right
    no-repeat;
  padding: 10px 20px 10px;
  margin-top: 20px;
}
</style>

<style>
.post-block h3 {
  margin-bottom: 16px;
  font-style: italic;
  font-weight: normal;
  font-family: 'Roboto', sans-serif;
  line-height: 1.5;
}
</style>
